export class FileHelpers {
public static  base64ToArrayBuffer(base64: string|undefined ) {
    if (base64){
        const binarystring = window.atob(base64);
        const len = binarystring.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i += 1) {
            bytes[i] = binarystring.charCodeAt(i);
        }
        return bytes.buffer;
    }
    return (null);
}

public static  getBinaryLengthOfBase64(base64: string|undefined) {
    if (base64){
        const binarystring = window.atob(base64);
        return  binarystring.length;
    }
    return (0);
}

public static  bytesToSize = (bytes: number): string => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const i = Math.floor(Math.floor(Math.log(bytes) / Math.log(1024)));
    // eslint-disable-next-line no-restricted-properties
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
};
}